export default "/fonts/poppins-v9-latin-700.woff2?c42d83a607aac6b2d4225ae46ea33599";